<template>
  <div
    class="panel-chart"
    @mouseover="showReport()"
    @mouseout="hideReport()"
  >
    <main class="flex flex-row justify-between items-center">
      <h5 class="mb-3 ml-3">{{ title[look] }}</h5>
      <div>
        <Button @click="pre()" icon="pi pi-angle-left" class="p-button-sm p-button-text" />
        <Button @click="next()" icon="pi pi-angle-right" class="p-button-sm p-button-text" />
      </div>
    </main>

    <template v-for="(lineItem, index) in lineStylesData">
      <Chart
        v-if="index == look"
        type="line"
        :data="lineItem"
        :options="basicOptions"
      />
      <div
        v-if="index == look"
        class="bg-gray-100 pt-2 pl-2 pb-2"
      >
        <!-- <div class="flex flex-row justify-between items-center mb-3" v-for="(item, idx) in tableData[0]" :key="idx"> -->
        <div class="flex flex-row items-center mb-3" v-for="(item, idx) in tableData[index]" :key="idx">
          <div class="data-icon mr-3"></div>
          <span class="table-title">
            {{ item.since }} ~ {{ item.until }}：{{ item.title }}
          </span>
        </div>
      </div>
    </template>

    <div class="pt-2 pl-2 pb-2 flex flex-row justify-between items-center">
      <span class="note-wording">{{lang['components']['List']['PanelChart']['footer_info']}}</span>
      <router-link :to="{ name: 'Report',params:{type: this.$route.params.type, id: this.$route.params.id, adaccount_id: chartCampaignAdaccountId, campaign_id: chartCampaignId} }">
        <span class="note-link">{{lang['components']['List']['PanelChart']['link_text']}}</span>
      </router-link>
    </div>
  </div>
</template>

<script>

import { ref, computed } from 'vue';
import Button from 'primevue/button';

export default {
  name: 'EventsListChart',
  props: {
    title: {
      type: String,
      default: 'xxx'
    },
    title: {
      type: Array,
      default: () => []
    },
    chartsData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    tableData: {
      type: Array,
      default: () => []
    },
    chartCampaignId: {
      type: String
    },
    chartCampaignAdaccountId: {
      type: String
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      look: 0
    }
  },
  methods: {
    pre(){
      this.look = parseInt(this.look) - parseInt(1)
      if(this.look == -1){
        this.look = parseInt(this.chartsData.length)
      }

      // console.log(this.chartsData.length);
      // console.log('pre:'+this.look);
    },
    next(){
      this.look = parseInt(this.look) + parseInt(1)
      if(this.look >= this.chartsData.length){
        this.look = 0
      }

      // console.log(this.chartsData.length);
      // console.log('next:'+this.look);
    }
  },
  components: {
    Button
  },
  setup(props) {
    const reportShow = ref(false);

    const basicOptions = computed(() => ({
      legend: {
        position: 'bottom',
        /* eslint-disable */
        onClick: function(e, legendItem) {
          let index = legendItem.datasetIndex;
          let ci = this.chart;
          let meta = ci.getDatasetMeta(index);

          // See controller.isDatasetVisible comment
          if (legendItem.text === undefined || legendItem.text === '優化建議') {
            // meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
          }
          // We hid a dataset ... rerender the chart
          ci.update();
        },
        /* eslint-disable */
        labels: {
          filter: function(e) {
            return e.text !== undefined;
          }
        }
      },
      tooltips: {
        mode: 'index',
        // intersect: false,
        position: 'nearest',
        filter: function(e) {
          const optimizeDatasetsCounts = 0;
          return e.datasetIndex >= optimizeDatasetsCounts;
        }
      },
      plugins: {
        legend: {
          display: false,
          labels: {
            color: '#495057'
          }
        }
      },
      scales: {
        xAxes: [{
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'YYYY/MM/DD'
            }
          }
        }],
        x: {
          ticks: {
            color: '#f02222',
          },
        },
        y: {
          ticks: {
            color: '#f02222'
          },
        }
      }
    }));

    const lineStylesData = computed(() => {

      //if (props.tableData.length <= 0) {
      return props.chartsData;
      /* } else {
        // 圖畫最大值
        const maxDataArray = [];
        props.chartsData.datasets.map((e) => {
          maxDataArray.push(Math.max(...e.data.map(p => p.y)));
        });
        const maxData = 20 - Math.max(...maxDataArray) % 20 > 0 ? Math.max(...maxDataArray) + 20 - Math.max(...maxDataArray) % 20 : Math.max(...maxDataArray);

        let optimizeDatasets = [];
        for (let idx = 0; idx < props.tableData.length; idx++) {
          let item = {
            data: [
              {
                x: new Date(props.tableData[idx].since),
                y: 0
              },
              {
                x: new Date(props.tableData[idx].since),
                y: maxData
              }
            ],
            pointRadius: 0,
            fill: false,
            borderColor: '#B9BDCD',
            pointHoverBackgroundColor: '#FA9E76',
            tension: .4,
            showLine: true
          }
          if (idx === 0) {
            item.label = '優化建議';
          }
          optimizeDatasets.push(item);
        }
        let finial = {...props.chartsData};
        finial.datasets = [...optimizeDatasets, ...finial.datasets];
        console.log(finial);
        return finial;
        // return props.chartsData;
      } */

    });

    const showReport = () => {
      reportShow.value = true;
    };

    const hideReport = () => {
      reportShow.value = false;
    }

    return {
      reportShow,
      lineStylesData,
      basicOptions,
      showReport,
      hideReport
    }
  }
};
</script>

<style lang="css" scoped>

.panel-chart {
  width: 300px;
  height: auto;
}

h5 {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: #7E7E7E;
}

.table-title {
  font-family: PingFang HK;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;
  color: #404040;
}

.data-icon {
  width: 5px;
  height: 5px;
  background: #FA9E76;
  border-radius: 100%;
}

.note-wording {
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 14px;
  color: #7E7E7E;
}

.note-link {
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  text-decoration-line: underline;
  color: #72B6F4;
  cursor: pointer;
}

</style>
